export default __webpack_public_path__ + "static/media/sh1.d3e64624.jpg";